// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ProjectStatus } from "./ProjectStatus";
import {
  ProjectStatusFromJSON,
  ProjectStatusFromJSONTyped,
  ProjectStatusToJSON,
  ProjectStatusToJSONTyped,
} from "./ProjectStatus";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 * Project response that hides internal fields.
 * @export
 * @interface ProjectResponse
 */
export interface ProjectResponse {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  status?: ProjectStatus;
  /**
   *
   */
  code: string;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  description: string;
  /**
   *
   */
  fileLakeId?: string | null;
  /**
   *
   */
  location?: Point | null;
  /**
   *
   */
  locationName?: string | null;
  /**
   *
   */
  clientName?: string | null;
  /**
   *
   */
  createdBy: string;
  /**
   *
   */
  showOnboarding: boolean;
}

/**
 * Check if a given object implements the ProjectResponse interface.
 */
export function instanceOfProjectResponse(value: object): value is ProjectResponse {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("code" in value) || value["code"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  if (
    (!("createdBy" in (value as Record<string, any>)) &&
      !("created_by" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdBy"] === undefined &&
      (value as Record<string, any>)["created_by"] === undefined)
  )
    return false;
  if (
    (!("showOnboarding" in (value as Record<string, any>)) &&
      !("show_onboarding" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["showOnboarding"] === undefined &&
      (value as Record<string, any>)["show_onboarding"] === undefined)
  )
    return false;
  return true;
}

export function ProjectResponseFromJSON(json: any): ProjectResponse {
  return ProjectResponseFromJSONTyped(json, false);
}

export function ProjectResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProjectResponse {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    status: json["status"] == null ? undefined : ProjectStatusFromJSON(json["status"]),
    code: json["code"],
    slug: json["slug"] == null ? undefined : json["slug"],
    name: json["name"],
    description: json["description"],
    fileLakeId:
      json["file_lake_id"] === undefined
        ? undefined
        : json["file_lake_id"] === null
        ? null
        : json["file_lake_id"],
    location:
      json["location"] === undefined
        ? undefined
        : json["location"] === null
        ? null
        : PointFromJSON(json["location"]),
    locationName:
      json["location_name"] === undefined
        ? undefined
        : json["location_name"] === null
        ? null
        : json["location_name"],
    clientName:
      json["client_name"] === undefined
        ? undefined
        : json["client_name"] === null
        ? null
        : json["client_name"],
    createdBy: json["created_by"],
    showOnboarding: json["show_onboarding"],
  };
}

export function ProjectResponseToJSON(json: any): ProjectResponse {
  return ProjectResponseToJSONTyped(json, false);
}

export function ProjectResponseToJSONTyped(
  value?: ProjectResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    status: ProjectStatusToJSON(value["status"]),
    code: value["code"],
    slug: value["slug"],
    name: value["name"],
    description: value["description"],
    file_lake_id: value["fileLakeId"],
    location: PointToJSON(value["location"]),
    location_name: value["locationName"],
    client_name: value["clientName"],
    created_by: value["createdBy"],
    show_onboarding: value["showOnboarding"],
  };
}
